module.exports = __webpack_public_path__ + "img/bee.be5030ca.webp";